import React from "react";
import PropTypes from "prop-types";
import "./OptionNav.css";

OptionNav.propTypes = {
  icon: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  textColor: PropTypes.string, //#001a70 or #fff
  hasOptions: PropTypes.bool,
  onClick: PropTypes.func,
};

function OptionNav({
  icon = "http://placehold.jp/00bab4/ffffff/30x30.png",
  name = "",
  title = "",
  url = "",
  onClick = () => {},
  textColor = "#001a70",
  hasOptions = false,
  ...props
}) {
  const root = process.env.REACT_APP_CMS_STATIC;
  let r = new RegExp("^(?:[a-z]+:)?//", "i");
  return (
    <div className="d-flex justify-content-between px-3 py-2" onClick={onClick}>
      {url !== "" ? (
        <a
          href={url}
          target={url.includes("http") ? "_blank" : ""}
          rel="noreferrer"
          className="d-flex align-items-center nav-link"
        >
          <img
            className="optionIcon"
            src={r.test(icon) ? icon : root + icon}
            alt={name}
          />
          <span className="optionText" style={{ color: `${textColor}` }}>
            {title}
          </span>
        </a>
      ) : (
        <div className="d-flex align-items-center nav-link">
          <img
            className="optionIcon"
            src={r.test(icon) ? icon : root + icon}
            alt={name}
          />
          <span className="optionText" style={{ color: `${textColor}` }}>
            {title}
          </span>
        </div>
      )}

      {hasOptions && <div className="mt-2 text-white">►</div>}
    </div>
  );
}

export default OptionNav;
